import type { VFC } from 'react'
import { Timescale } from '@opallabs/concepts'
import { QuasiTabs } from '@opallabs/lapidary'
import { testFeature } from '@opallabs/principles'
import type { ModePickerProps } from './types'

const ModePicker: VFC<ModePickerProps> = ({
  mode = Timescale.Week,
  onModeChange,
}) => {
  const options = [
    { label: 'Week', value: Timescale.Week },
    { label: 'Month', value: Timescale.Month },
  ]
  if (!testFeature('simplified_ui'))
    options.unshift({ label: 'Day', value: Timescale.Day })

  return (
    <QuasiTabs
      aria-label="Calendar view"
      value={mode}
      onValueChange={(next) => onModeChange(next as Timescale)}
    >
      {options.map((option) => (
        <QuasiTabs.Option
          key={option.value}
          /* The legacy router switches views by clicking the option for the
             mode a `#day`, `#week` or `#month` address names. */
          data-timescale={option.value}
          value={option.value}
        >
          {option.label}
        </QuasiTabs.Option>
      ))}
    </QuasiTabs>
  )
}
ModePicker.displayName = 'Continuum: ModePicker ← Header'

export default ModePicker
